// Copied from platform-app components/pos/layout/addKeyLook.ts on 2026-10-14 for Super Admin → POS Defaults — keep in step with the original.
import type { CSSProperties } from 'react';
import { BUTTON_REGISTRY, type ButtonOverride } from '../../../config/buttonRegistry';
import { hasUserColours, resolveButtonLook } from '../../../config/buttonTheme';
import type { PreviewTheme } from './previewPalette';

/** The Custom Item button IS the keypad ADD key. It never lives on the rail, in More, or in a keypad slot. */
export const CUSTOM_ITEM_ID = 'custom-item';

/** True for ids that may appear on the side rail, in the More launcher or in a keypad slot. */
export const isAssignableAction = (id: string): boolean => id !== CUSTOM_ITEM_ID;

/**
 * Look of the keypad ADD key (the Custom Item button). Merchant colours win; without them
 * the ADD key is the registry green (#10b981, white text/icon). Both are identical in Light
 * and Dark. Mirrors AGENTIC_POS SaleKeypad's ADD key (--add-bg / --add-tx).
 */
export function resolveAddKeyLook(
  override: ButtonOverride | undefined,
  theme: PreviewTheme,
): { style: CSSProperties; fg: string } {
  if (hasUserColours(override)) return resolveButtonLook(CUSTOM_ITEM_ID, override, theme);
  const reg = BUTTON_REGISTRY[CUSTOM_ITEM_ID]!;
  return {
    style: { background: reg.bgColor, color: reg.textColor, border: `1px solid ${reg.bgColor}` },
    fg: reg.iconColor,
  };
}
